import React from "react";
import {
  StepPersonalData,
  StepFinancialData,
  StepBeneficiaries,
  StepModalities,
} from "../StepRVForms";

interface ShowFormActiveProps {
  stepActive: number;
  assured: any;
  serviceData: any[];
  register: any;
  objSendForm: any;
  afpData: any[];
  prestacionWatch: any;
  selectSalud: any;
  coverageData: any[];
  validationAverageProm: () => boolean | undefined;
  averageRenum: any;
  handleSubmit: any;
  nextActiveStep: (id: number) => void;
  setObjSendForm: (data: any) => void;
  disabledStepGeneral: () => boolean | undefined;
  methodFinancial: any;
  handleSubmitFinancial: any;
  setValueFinancial: any;
  registerFinancial: any;
  errors: any;
  formatCurrency: (value: number) => string;
  capitalPension: any;
  dateDevOrig: any;
  dateDeven: any;
  handleOpenModalAddBeneficiaries: () => void;
  parients: any[];
  relationshipData: any[];
  saludData: any[];
  genrerData: any[];
  renderName: (value: string, data: any[]) => string;
  handleOpenModalEditBeneficiarie: (parient: any) => void;
  deleteParient: (parient: any) => void;
  handleOpenModalAddModalities: () => void;
  modalities: any[];
  handleOpenModalEditModalitie: (modalitie: any) => void;
  deleteModalitie: (modalitie: any) => void;
  handleSubmitForm: (data: any) => void;
  loadingSubmit: boolean;
}

const ShowFormActive: React.FC<ShowFormActiveProps> = ({
  stepActive,
  assured,
  serviceData,
  register,
  objSendForm,
  afpData,
  prestacionWatch,
  selectSalud,
  coverageData,
  validationAverageProm,
  averageRenum,
  handleSubmit,
  nextActiveStep,
  setObjSendForm,
  disabledStepGeneral,
  methodFinancial,
  handleSubmitFinancial,
  setValueFinancial,
  registerFinancial,
  errors,
  formatCurrency,
  capitalPension,
  dateDevOrig,
  dateDeven,
  handleOpenModalAddBeneficiaries,
  parients,
  relationshipData,
  saludData,
  genrerData,
  renderName,
  handleOpenModalEditBeneficiarie,
  deleteParient,
  handleOpenModalAddModalities,
  modalities,
  handleOpenModalEditModalitie,
  deleteModalitie,
  handleSubmitForm,
  loadingSubmit,
}) => {
  const stepsMap: Record<number, React.ReactNode> = {
    1: (
      <StepPersonalData
        assured={assured}
        serviceData={serviceData}
        register={register}
        objSendForm={objSendForm}
        afpData={afpData}
        prestacionWatch={prestacionWatch}
        selectSalud={selectSalud}
        coverageData={coverageData}
        validationAverageProm={validationAverageProm}
        averageRenum={averageRenum}
        handleSubmit={handleSubmit}
        nextActiveStep={nextActiveStep}
        setObjSendForm={setObjSendForm}
        disabledStepGeneral={disabledStepGeneral}
      />
    ),
    2: (
      <StepFinancialData
        methodFinancial={methodFinancial}
        handleSubmitFinancial={handleSubmitFinancial}
        nextActiveStep={nextActiveStep}
        setObjSendForm={setObjSendForm}
        objSendForm={objSendForm}
        setValueFinancial={setValueFinancial}
        registerFinancial={registerFinancial}
        errors={errors}
        formatCurrency={formatCurrency}
        capitalPension={capitalPension}
        dateDevOrig={dateDevOrig}
        dateDeven={dateDeven}
      />
    ),
    3: (
      <StepBeneficiaries
        handleOpenModalAddBeneficiaries={handleOpenModalAddBeneficiaries}
        parients={parients}
        relationshipData={relationshipData}
        saludData={saludData}
        genrerData={genrerData}
        renderName={renderName}
        handleOpenModalEditBeneficiarie={handleOpenModalEditBeneficiarie}
        deleteParient={deleteParient}
        nextActiveStep={nextActiveStep}
        objSendForm={objSendForm}
      />
    ),
    4: (
      <StepModalities
        handleOpenModalAddModalities={handleOpenModalAddModalities}
        modalities={modalities}
        handleOpenModalEditModalitie={handleOpenModalEditModalitie}
        deleteModalitie={deleteModalitie}
        objSendForm={objSendForm}
        setObjSendForm={setObjSendForm}
        parients={parients}
        handleSubmitForm={handleSubmitForm}
        loadingSubmit={loadingSubmit}
      />
    ),
  };

  return stepsMap[stepActive] || null;
};

export default ShowFormActive;